import React from "react";
import { useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import CardItem from "../components/CardItem";
import MainNavigation from "../components/MainNavigation";

const ViewAllProduct = () => {
  const location = useLocation();
  const items = location.state;
  const title = `${items?.categoryId?.name} All Menus Items`;
  return (
    <div className="cart">
      <Container>
        <MainNavigation title={title} />
        <CardItem data={items?.data} categoryId={items?.categoryId} />
      </Container>
    </div>
  );
};

export default React.memo(ViewAllProduct);
